var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.country
    ? _c("img", {
        directives: [
          {
            name: "tippy",
            rawName: "v-tippy",
            value: _vm.country.name,
            expression: "country.name",
          },
        ],
        staticClass: "flag",
        attrs: { width: "24", src: _vm.country.local, alt: _vm.country.name },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }